import axios from "axios";





export const makeRequest = axios.create({
  baseURL: 'https://back.kayanmarketeg.com/api',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json', // Ensure the API knows you accept JSON responses
  },
  // withCredentials: true, // For cookies and authentication
});



